/* global */
import React from 'react';
import { useSelector } from 'react-redux';

import UrlWidgets from './UrlWidgets';

const UrlWidgetWrapper = () => {
  const setting = useSelector((state) => state.setting.data);

  if (!setting) {
    return null;
  }

  return <UrlWidgets />;
};

export default UrlWidgetWrapper;
